import { Component, Input, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ButtonIconPosition, ButtonSkin, ButtonTextAlignment, Colors, FormFieldDecoration, IconName, IconSize, Positions } from '@evonik/evo';
import { User, UserAuthorities } from '../../models/user.model';
import { LanguageService } from '../../services/language.service';
import { UserService } from '../../services/user.service';
import { WelcomeScreenService } from '../../services/welcome-screen.service';
import { ConfigService, SessionService } from '@evonik/ng-core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
    private authService = inject(UserService);
    languageService = inject(LanguageService);
    welcomeScreenService = inject(WelcomeScreenService);
    private configService = inject(ConfigService);
    private session = inject(SessionService);


    @Input() showContent = true;

    iconSizes = IconSize;
    colors = Colors;
    positions = Positions;
    userName: string = '';
    showProfileMenu: boolean = false;
    iconNames = IconName;
    buttonSkins = ButtonSkin;
    iconPositions = ButtonIconPosition;
    textAlignments = ButtonTextAlignment;
    formFieldDecoration = FormFieldDecoration;

    currentUser: User | undefined;

    UserAuthorities = UserAuthorities;

    selectedLanguage = new UntypedFormControl('en');
    showIntroScreenControl = new UntypedFormControl(true);

    anaCustomViewTypeUrl = "#";
    helpUrl = "faq";

    constructor() {

        this.currentUser = this.authService.currentUser;
        this.userName = `${this.currentUser?.firstName} ${this.currentUser?.lastName}`

        this.showIntroScreenControl.setValue(this.welcomeScreenService.show);

        this.showIntroScreenControl.valueChanges.subscribe(value => {
            this.welcomeScreenService.show = value;
        })

        this.selectedLanguage.setValue(this.languageService.currentLanguage);

        this.selectedLanguage.valueChanges.subscribe(value => {
            this.languageService.currentLanguage = value;
        })

        this.anaCustomViewTypeUrl = this.configService.getConfig().get('anaCustomViewTypeUrl');
    }

    toggleProfileMenu(): void {
        this.showProfileMenu = !this.showProfileMenu;
    }

    logout(){
        this.session.logout();
    }
}
